const minutesFromWallClock = (datetime: string): number | null => {
  const normalized = datetime.trim().replace("T", " ");
  const timePart = normalized.slice(11, 16);
  const match = /^(\d{2}):(\d{2})$/.exec(timePart);

  if (!match) {
    return null;
  }

  return Number(match[1]) * 60 + Number(match[2]);
};

/** True when offered starts skip more than one grid step (absence, pause, or organization time). */
export const hasSlotListGap = (datetimes: string[], stepMinutes = 15): boolean => {
  const minutes = datetimes
    .map(minutesFromWallClock)
    .filter((value): value is number => value !== null)
    .sort((left, right) => left - right);

  for (let index = 1; index < minutes.length; index += 1) {
    if (minutes[index] - minutes[index - 1] > stepMinutes) {
      return true;
    }
  }

  return false;
};
